/**
 * Errores con los que el servidor devuelve al login (`/?error=<código>`) tras pasar por Google.
 * Sin "use client" a propósito: lo importan tanto las rutas de `app/api/auth` como la pantalla de login.
 * Ver docs/plan-backend-google-cloud.md, sección 3.
 */
export const ERRORES_GOOGLE = ["cancelado", "sin-alta", "dominio", "inactivo", "fallo"] as const;
export type ErrorGoogle = (typeof ERRORES_GOOGLE)[number];
